import React from 'react';
import { Link, router } from '@inertiajs/react';
import { TOPIC_GROUPS, topicPath } from './topics';

type Props = { current: string; toolCount: number };

// The left-hand table of contents (md and up), and a sticky <select> below md.
// Both come from the same TOPIC_GROUPS.
const DocsNav: React.FC<Props> = ({ current, toolCount }) => (
  <>
    <nav className="hidden w-52 flex-none self-start text-sm md:sticky md:top-4 md:block" aria-label="接入文档目录">
      {TOPIC_GROUPS.map((group) => (
        <div key={group.label} className="mb-4">
          <div className="mb-1 ml-2.5 text-[11px] font-semibold tracking-wider text-gray-400">{group.label}</div>
          {group.items.map((item) => {
            const sub = item.id === 'tools' ? String(toolCount) : item.sub;
            const active = item.id === current;
            return (
              <Link
                key={item.id}
                href={topicPath(item.id)}
                aria-current={active ? 'page' : undefined}
                className={`flex justify-between gap-2 rounded-md px-2.5 py-1.5 ${
                  active ? 'bg-blue-50 font-semibold text-blue-600' : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <span>{item.label}</span>
                {sub && <span className="whitespace-nowrap text-xs font-normal text-gray-400">{sub}</span>}
              </Link>
            );
          })}
        </div>
      ))}
    </nav>

    <label className="sticky top-0 z-10 -mx-4 mb-4 flex items-center gap-2 border-b border-gray-200 bg-white px-4 py-2 text-xs text-gray-500 md:hidden">
      目录
      <select
        value={current}
        onChange={(e) => router.visit(topicPath(e.target.value))}
        className="flex-1 rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-900"
      >
        {TOPIC_GROUPS.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.items.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  </>
);

export default DocsNav;
